import './App.css';
import AllRoutes from './Sagar/page/AllRoutes';
// import { Navbar } from './DurgeshFolder/AllRoutes/Navbar';
// import {AllRoutes} from "./DurgeshFolder/AllRoutes/Routes"

// import AllRoutes from './Sagar/page/AllRoutes';
function App() {
  return (
    <div className="App">
      
      <AllRoutes/> 




{/*  Durgesh Routes for individual check------------- */}
      {/* <Navbar />
      <AllRoutes /> */}
    </div>
  );
}

export default App;

export const serverUrl='https://fashion-hunter.onrender.com'
